'use es6';

import getObjectDefinitions from './getObjectDefinitions';
const getMapOf = (keyProp, valueProp) => {
  return getObjectDefinitions().reduce((map, objectDefinition) => {
    const key = objectDefinition.get(keyProp);
    const value = objectDefinition.get(valueProp);
    map[key] = value;
    return map;
  }, {});
};
const shouldEnableUseInAssociations = (objectDefinition, {
  isUngated,
  hasScope
}) => {
  const isEnabled = objectDefinition.get('enableAsAssociatedType');
  if (!isEnabled) {
    return false;
  }
  const hasAccess = objectDefinition.get('hasAccess');
  return hasAccess(isUngated, hasScope);
};
const ObjectDefinitionProvider = {
  getEnabledForAssociations: (...args) => getObjectDefinitions().filter(record => shouldEnableUseInAssociations(record, ...args)),
  getAll: () => getObjectDefinitions(),
  getFiltered: (...args) => getObjectDefinitions().filter(...args),
  getById: id => getObjectDefinitions().find(({
    objectTypeId
  }) => id === objectTypeId),
  getMapOf
};
export default ObjectDefinitionProvider;